// Uses
const floatToMoney = require('./floatToMoney');
const moneyToFloat = require('./moneyToFloat');
const GlobalAlerts = require('global_alerts');
const Lang = require('lang');

// Componentes geral
const $modalMapaPercurso = $('#modal-mapa-percurso');
const $form = $modalMapaPercurso.find('#form-mapa-percurso');
const $map = $modalMapaPercurso.find('[data-gmap]');
const $divMapaPercuros = $modalMapaPercurso.find('#google-maps-selector');
const $divFieldsPercurso = $modalMapaPercurso.find('#fields-percurso');

// Botoes
const $btnPrev = $modalMapaPercurso.find('.js-previous');
const $btnNext = $modalMapaPercurso.find('.js-next');
const $submitBtn = $modalMapaPercurso.find('.js-submit');

// Inputs / Labels
const $distanceLabel = $modalMapaPercurso.find('.gmaps-selector__distance-value');
const $distanceInput = $modalMapaPercurso.find('[name=kilometragem]');
const $routeInput = $modalMapaPercurso.find('[name=route]');
const $valorKmInput = $modalMapaPercurso.find('[name=valorKm]');
const $valorInput = $modalMapaPercurso.find('[name=valor]');
const $dataInput = $modalMapaPercurso.find('[name=data]');
const $obsInput = $modalMapaPercurso.find('[name=obs]');
const $idInput = $modalMapaPercurso.find('[name=id]');

function MapaPercursoModalHandler() {
  if (!$modalMapaPercurso.length) {
    return;
  }

  $modalMapaPercurso.on('shown.bs.modal', function () {
    // Evento disparado quando o mapa é exibido / modal com o mapa é aberta
    $map[0].dispatchEvent(new Event('mapShown'));

    // Pega posição atual do navegador e dispara um evento no document
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        // Dispara um evento sobre o mapa de que a rota foi processada
        // para outras funcoes conseguirem lidar com o resultado
        const event = new CustomEvent('locationUpdated', {
          'detail': position
        });
        document.dispatchEvent(event);
      });
    }
  });

  // Desabilita o botão enter de dar submit no form
  // para que a pesquisa no autocomplete do google maps
  // nao dê submit ao escolher um dos itens no dropdown
  $form.on('keypress', function (event) {
    return event.keyCode != 13;
  });

  // Evento disparado quando uma rota é processada pela classe Gmaps
  $map[0].addEventListener('routeProcessed', routeProcessedHandler);

  $btnNext.on('click', function () {
    if (validateLocationPoinst()) {
      handleSearchedPoints();
      toggleHiddenButtons();
    }
  });

  $btnPrev.on('click', function () {
    handleSearchedPoints();
    toggleHiddenButtons();
  });

  // Atualiza total conforme usuario digita o valor por KM
  $valorKmInput.on('keyup', function () {
    updateTotal();
  });

  // Atualiza total ao alterar data
  $dataInput.on('change', function () {
    if ($form[0].hasAttribute('data-calculate-valor-km-politica')) {
      calculateValorKmPolitica();
    }
  });

  if ($distanceInput.val() > 0) {
    $btnNext.removeClass('hidden');
  }
}

/**
 * Handler do evento routeProcessed no mapa
 *
 * @param  event
 */
function routeProcessedHandler(event) {
  if (!event.detail) {
    // Se o detail for null, quer dizer que não tem rota,
    // então zera os campos
    $btnNext.addClass('hidden');
    $routeInput.val(null);
    $distanceInput.val(null);
    $distanceLabel.text('0');
    updateTotal();

    return;
  }

  // Pega rota principal retornada
  const route = event.detail.routes[0];

  // Soma a distancia entre os pedaços da rota
  let distance = route.legs.reduce(function (carry, item) {
    return carry + item.distance.value;
  }, 0);
  // Convertido de centimetros para km com 2 casas decimais
  distance = (distance / 1000).toFixed(2);

  // Adicionado string equivalente a rota em um campo hidden
  $routeInput.val(JSON.stringify(route));

  // Atualizado campos de quilometragem
  $distanceInput.val(distance);
  $distanceLabel.text(distance.replace('.', ','));

  if ($form[0].hasAttribute('data-calculate-valor-km-politica')) {
    calculateValorKmPolitica();
  } else {
    updateTotal();
  }

  // Ao fim da pesquisa, somente mostra o botão de "proximo" se caso
  // o botão "anterior" estiver escondido na tela, para não bugar caso
  // o usuario pesquise a rota e clique em "proximo" antes do termino da
  // request
  if ($btnPrev.hasClass('hidden')) {
    $btnNext.removeClass('hidden');
  }
}

/**
 * Faz o gerenciamento dos botoes e divs na tela que devem
 * aparecer em cada etapa dos botoes "proximo" e "anterior"
 */
function toggleHiddenButtons() {
  $divMapaPercuros.toggleClass('hidden');
  $divFieldsPercurso.toggleClass('hidden');

  $submitBtn.toggleClass('hidden');
  $btnPrev.toggleClass('hidden');
  $btnNext.toggleClass('hidden');
}

/**
 * Atualiza o valor total da despesa
 */
function updateTotal() {
  const valorKm = moneyToFloat($valorKmInput.val());
  const distance = $distanceInput.val();

  const total = floatToMoney((distance * valorKm).toFixed(2));

  $valorInput.val(total).trigger('change');
}

function calculateValorKmPolitica() {
  const id = $idInput.val();
  const distance = $distanceInput.val();
  const data = $dataInput.val();

  if (!parseFloat(distance) || !data) {
    return;
  }

  $.ajax({
    type: 'POST',
    url: route('app.despesas.calcular-valor-km-politica'),
    dataType: 'json',
    data: { kilometragem: distance, data: data, rejectId: id }
  }).done(response => {
    const inputs = response.data;
    $valorInput.val(floatToMoney(response.data.valor.toFixed(2))).trigger('change');
    $valorKmInput.val(response.data.valorKm);
    $obsInput.val(response.data.obs);
  }).fail(response => {
    console.error(response);
    GlobalAlerts.createAndShow({
      title: Lang.get('js/src/classes/gmaps.ops'),
      message: Lang.get('js/src/classes/gmaps.something_went_wrong'),
      type: 'danger'
    });
  });
}

/**
 * Para cada input de ponto ele verifica se se o nome ainda está em branco (Sem selecionar um ponto)
 * E se for branco ele dá o alerta de que há pontos inválidos e retorna false o que não deixa prosseguir.
 */
function validateLocationPoinst() {
  let next = true;
  $('.pac-target-input').each(function (i, e) {
    if (e.name == 'pontosPesquisados[]') {
      next = false;
      bootbox.dialog({
        title: Lang.get('js/src/classes/gmaps.ops'),
        message: Lang.get('js/src/classes/gmaps.point_selection_error'),
        buttons: {
          cancel: {
            label: Lang.get('js/common/form/button.cancel'),
            className: 'btn-danger'
          }
        }
      });
    }
  });
  return next;
}

/**
 * Busca todos inputs de pontos pesquisados e de cada um adiciona o id e value em forma de objeto
 * Em um array que será enviado na requisição através de um campo hidden.
 */
function handleSearchedPoints() {
  const pontosPesquisados = [];

  if ($('#objPontosPesquisados').length) {
    $('#objPontosPesquisados').remove();
    return;
  }

  $('input[name*="pontosPesquisados"').each(function (i, input) {
    const placeId = input.name.match(/\[(.*?)\]/)[1];
    if (placeId !== 'template') {
      pontosPesquisados.push({
        placeId: placeId,
        search: input.value.replace(/['"]/g, '`'),
      });
    }
  });
  $('#google-maps-selector').append(`<input id="objPontosPesquisados" type="hidden" name="objPontosPesquisados" value='${JSON.stringify(pontosPesquisados)}'>`);
}

exports.init = MapaPercursoModalHandler;
